module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEnSURBVHgB7ZTdjcIwEITHpysgJVACJYQO7jrIVYCuEkoIJdABdEA6wB0AFYRZsUgm8l+c8IDESCvLztifvPEu8NG7yQwX+r5fc/gJ+DtjzD898n3DWHFuUSoedOojUk/FOKp3kXv2FwrE21w4rBgy7nOBRbBSYDGsBDgJ5gB/dRoFToYp0OJ+wyjQB7sgLIsJQF+diWkBvzpNW1C6f6/TeB3SXGOiBKg12KSMYmrxAoXSKGk4MAV/qQPoX3JYDpYt9x6QIycNbcLXaBc7OXF21irMBeQ3eXU7z3qlwKcbB+vMecp14oZnz97Hi62yYCOBWUp2kDmBWe0qArxihL5zjQIkSIDyKFoti46x9rQm+VcWg/ZmMFJ6cE3YVucN/O1tR0+Hj+bWDTCX+yBEt466AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fugaiactive.png
// module id = uhPq
// module chunks = 1